import { atom } from 'recoil';

import { FilterModalTypes } from '../../components/FilterModal';
import { OrderByModalTypes } from '../../components/OrderByModal';
import { TableHeadItemOrderBy } from '../../components/TableHead';

interface FixedFeeOrderByAtom {
  availableOrderBy: OrderByModalTypes.OrderByType;
  selectedOrderBy: TableHeadItemOrderBy | undefined;
  appliedOrderBy: TableHeadItemOrderBy | undefined;
}

export const fixedFeeTermsFiltersAtom = atom<FilterModalTypes.FilterAtom>({
  key: 'fixedFeeTermsFiltersAtom',
  default: {
    availableFilters: [
      // {
      //   title: 'Evento',
      //   type: 'boolean',
      //   fieldName: 'eventId',
      //   optionsColumns: 2,
      //   options: [
      //     { label: 'Contratação', value: 'Contracting' },
      //     { label: 'Substituição', value: 'Substitution' },
      //   ],
      // },
      {
        title: 'Status',
        type: 'section',
        fieldName: 'statusIds',
        optionsColumns: 2,
        options: [
          { label: 'Pendente', value: 'Pending' },
          { label: 'Aceito', value: 'Accepted' },
          { label: 'Ativo', value: 'Active' },
          { label: 'Em rescisão', value: 'Terminating' },
          { label: 'Recusado', value: 'Refused' },
          { label: 'Encerrado', value: 'Closed' },
          { label: 'Expirado', value: 'Expired' },
          { label: 'Cancelado', value: 'Canceled' },
        ],
      },
      {
        title: 'Data de contratação',
        type: 'dateRange',
        fieldName: 'hiringDate',
        placeholder: 'Selecione a data',
        showOnlyIf: () => true,
      },
      {
        title: 'Taxa(%)',
        type: 'multiSlider',
        fieldName: 'feeAmount',
        labelType: 'percentage',
        step: 0.25,
        min: 0,
        max: 10,
      },
    ],
    selectedFilters: [],
    appliedFilters: [],
  },
});

export const fixedFeeTermsOrderByInitialValue: FixedFeeOrderByAtom = {
  availableOrderBy: [
    {
      label: 'Termo',
      value: 'term',
    },
    {
      label: 'Cliente',
      value: 'customerName',
    },
    {
      label: 'Taxa (%)',
      value: 'feeRate',
    },
    {
      label: 'Data de contratação',
      value: 'contractDate',
    },
    {
      label: 'Patrimônio líquido',
      value: 'netWorth',
    },
  ],
  selectedOrderBy: undefined,
  appliedOrderBy: undefined,
};

export const fixedFeeTermsOrderByAtom = atom<FixedFeeOrderByAtom>({
  key: 'fixedFeeTermsOrderByAtom',
  default: fixedFeeTermsOrderByInitialValue,
});
